/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FeedModelMeImageRequest,
    GetModelMeResultResponse,
    GetPersonalDataResponse,
    GetSignedUrlToUploadModelMeImageRequest,
    GetSignedUrlToUploadModelMeImageResponse,
    HasModelMeProcessTriggeredListingsResponse,
    UploadModelMeImageResponse,
    UploadPersonalDataRequest,
} from '../models';

export interface ModelMeApiControllerApproveModelMeImageRequest {
    storeId: string;
    listingId: string;
    imageId: string;
}

export interface ModelMeApiControllerDismissModelMeImageRequest {
    storeId: string;
    listingId: string;
    imageId: string;
}

export interface ModelMeApiControllerFeedbackModelMeImageRequest {
    storeId: string;
    listingId: string;
    imageId: string;
    feedModelMeImageRequest: FeedModelMeImageRequest;
}

export interface ModelMeApiControllerGetModelMeResultRequest {
    storeId: string;
    listingId: string;
}

export interface ModelMeApiControllerGetPersonalDataRequest {
    storeId: string;
}

export interface ModelMeApiControllerGetSignedUrlToUploadModelMeImageRequest {
    storeId: string;
    getSignedUrlToUploadModelMeImageRequest: GetSignedUrlToUploadModelMeImageRequest;
}

export interface ModelMeApiControllerHasModelMeProcessTriggeredListingsRequest {
    storeId: string;
}

export interface ModelMeApiControllerTriggerModelMeProcessRequest {
    storeId: string;
    listingId: string;
}

export interface ModelMeApiControllerUploadModelMeImageRequest {
    storeId: string;
    imageType: ModelMeApiControllerUploadModelMeImageImageTypeEnum;
    file?: Blob;
}

export interface ModelMeApiControllerUploadPersonalDataRequest {
    storeId: string;
    uploadPersonalDataRequest: UploadPersonalDataRequest;
}

/**
 * 
 */
export class ModelMeApi extends runtime.BaseAPI {

    /**
     */
    async modelMeApiControllerApproveModelMeImageRaw(requestParameters: ModelMeApiControllerApproveModelMeImageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerApproveModelMeImage.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling modelMeApiControllerApproveModelMeImage.');
        }

        if (requestParameters.imageId === null || requestParameters.imageId === undefined) {
            throw new runtime.RequiredError('imageId','Required parameter requestParameters.imageId was null or undefined when calling modelMeApiControllerApproveModelMeImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}/modelMeImages/{imageId}:approve`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))).replace(`{${"imageId"}}`, encodeURIComponent(String(requestParameters.imageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerApproveModelMeImage(requestParameters: ModelMeApiControllerApproveModelMeImageRequest): Promise<void> {
        await this.modelMeApiControllerApproveModelMeImageRaw(requestParameters);
    }

    /**
     */
    async modelMeApiControllerDismissModelMeImageRaw(requestParameters: ModelMeApiControllerDismissModelMeImageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerDismissModelMeImage.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling modelMeApiControllerDismissModelMeImage.');
        }

        if (requestParameters.imageId === null || requestParameters.imageId === undefined) {
            throw new runtime.RequiredError('imageId','Required parameter requestParameters.imageId was null or undefined when calling modelMeApiControllerDismissModelMeImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}/modelMeImages/{imageId}:dismiss`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))).replace(`{${"imageId"}}`, encodeURIComponent(String(requestParameters.imageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerDismissModelMeImage(requestParameters: ModelMeApiControllerDismissModelMeImageRequest): Promise<void> {
        await this.modelMeApiControllerDismissModelMeImageRaw(requestParameters);
    }

    /**
     */
    async modelMeApiControllerFeedbackModelMeImageRaw(requestParameters: ModelMeApiControllerFeedbackModelMeImageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerFeedbackModelMeImage.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling modelMeApiControllerFeedbackModelMeImage.');
        }

        if (requestParameters.imageId === null || requestParameters.imageId === undefined) {
            throw new runtime.RequiredError('imageId','Required parameter requestParameters.imageId was null or undefined when calling modelMeApiControllerFeedbackModelMeImage.');
        }

        if (requestParameters.feedModelMeImageRequest === null || requestParameters.feedModelMeImageRequest === undefined) {
            throw new runtime.RequiredError('feedModelMeImageRequest','Required parameter requestParameters.feedModelMeImageRequest was null or undefined when calling modelMeApiControllerFeedbackModelMeImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}/modelMeImages/{imageId}:feedback`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))).replace(`{${"imageId"}}`, encodeURIComponent(String(requestParameters.imageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.feedModelMeImageRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerFeedbackModelMeImage(requestParameters: ModelMeApiControllerFeedbackModelMeImageRequest): Promise<void> {
        await this.modelMeApiControllerFeedbackModelMeImageRaw(requestParameters);
    }

    /**
     */
    async modelMeApiControllerGetModelMeResultRaw(requestParameters: ModelMeApiControllerGetModelMeResultRequest): Promise<runtime.ApiResponse<Array<GetModelMeResultResponse>>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerGetModelMeResult.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling modelMeApiControllerGetModelMeResult.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}:getModelMeResult`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerGetModelMeResult(requestParameters: ModelMeApiControllerGetModelMeResultRequest): Promise<Array<GetModelMeResultResponse>> {
        const response = await this.modelMeApiControllerGetModelMeResultRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async modelMeApiControllerGetPersonalDataRaw(requestParameters: ModelMeApiControllerGetPersonalDataRequest): Promise<runtime.ApiResponse<GetPersonalDataResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerGetPersonalData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:getPersonalData`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerGetPersonalData(requestParameters: ModelMeApiControllerGetPersonalDataRequest): Promise<GetPersonalDataResponse> {
        const response = await this.modelMeApiControllerGetPersonalDataRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async modelMeApiControllerGetSignedUrlToUploadModelMeImageRaw(requestParameters: ModelMeApiControllerGetSignedUrlToUploadModelMeImageRequest): Promise<runtime.ApiResponse<GetSignedUrlToUploadModelMeImageResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerGetSignedUrlToUploadModelMeImage.');
        }

        if (requestParameters.getSignedUrlToUploadModelMeImageRequest === null || requestParameters.getSignedUrlToUploadModelMeImageRequest === undefined) {
            throw new runtime.RequiredError('getSignedUrlToUploadModelMeImageRequest','Required parameter requestParameters.getSignedUrlToUploadModelMeImageRequest was null or undefined when calling modelMeApiControllerGetSignedUrlToUploadModelMeImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:getSignedUrlToUploadModelMeImage`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.getSignedUrlToUploadModelMeImageRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerGetSignedUrlToUploadModelMeImage(requestParameters: ModelMeApiControllerGetSignedUrlToUploadModelMeImageRequest): Promise<GetSignedUrlToUploadModelMeImageResponse> {
        const response = await this.modelMeApiControllerGetSignedUrlToUploadModelMeImageRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async modelMeApiControllerHasModelMeProcessTriggeredListingsRaw(requestParameters: ModelMeApiControllerHasModelMeProcessTriggeredListingsRequest): Promise<runtime.ApiResponse<HasModelMeProcessTriggeredListingsResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerHasModelMeProcessTriggeredListings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:hasModelMeProcessTriggeredListings`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerHasModelMeProcessTriggeredListings(requestParameters: ModelMeApiControllerHasModelMeProcessTriggeredListingsRequest): Promise<HasModelMeProcessTriggeredListingsResponse> {
        const response = await this.modelMeApiControllerHasModelMeProcessTriggeredListingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async modelMeApiControllerTriggerModelMeProcessRaw(requestParameters: ModelMeApiControllerTriggerModelMeProcessRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerTriggerModelMeProcess.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling modelMeApiControllerTriggerModelMeProcess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}:triggerModelMeProcess`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerTriggerModelMeProcess(requestParameters: ModelMeApiControllerTriggerModelMeProcessRequest): Promise<void> {
        await this.modelMeApiControllerTriggerModelMeProcessRaw(requestParameters);
    }

    /**
     */
    async modelMeApiControllerUploadModelMeImageRaw(requestParameters: ModelMeApiControllerUploadModelMeImageRequest): Promise<runtime.ApiResponse<UploadModelMeImageResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerUploadModelMeImage.');
        }

        if (requestParameters.imageType === null || requestParameters.imageType === undefined) {
            throw new runtime.RequiredError('imageType','Required parameter requestParameters.imageType was null or undefined when calling modelMeApiControllerUploadModelMeImage.');
        }

        const queryParameters: any = {};

        if (requestParameters.imageType !== undefined) {
            queryParameters['imageType'] = requestParameters.imageType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/stores/{storeId}:uploadModelMeImage`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerUploadModelMeImage(requestParameters: ModelMeApiControllerUploadModelMeImageRequest): Promise<UploadModelMeImageResponse> {
        const response = await this.modelMeApiControllerUploadModelMeImageRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async modelMeApiControllerUploadPersonalDataRaw(requestParameters: ModelMeApiControllerUploadPersonalDataRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling modelMeApiControllerUploadPersonalData.');
        }

        if (requestParameters.uploadPersonalDataRequest === null || requestParameters.uploadPersonalDataRequest === undefined) {
            throw new runtime.RequiredError('uploadPersonalDataRequest','Required parameter requestParameters.uploadPersonalDataRequest was null or undefined when calling modelMeApiControllerUploadPersonalData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:uploadPersonalData`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.uploadPersonalDataRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async modelMeApiControllerUploadPersonalData(requestParameters: ModelMeApiControllerUploadPersonalDataRequest): Promise<void> {
        await this.modelMeApiControllerUploadPersonalDataRaw(requestParameters);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ModelMeApiControllerUploadModelMeImageImageTypeEnum {
    Face = 'face',
    Body = 'body'
}
